<template>
  <div class="box">
    <div class="top">
      <div class="left">
        {{ data.xx.qy.title }}
      </div>
      <div class="center">
        <img :src="data.xx.user.avatar">
        <!-- <img src="../../assets/images/fkjz/图层 10.png" alt=""> -->
      </div>
      <div class="right">
        <div class="xx">
          <p>
          姓名: <span>{{ data.xx.user.name }}</span>
          <!-- 姓名: <span>王王王王</span> -->
          </p>
          <p>
          <!-- 小区: <span>小区小区</span> -->
          小区: <span>{{ data.xx.user.village }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="wyqy">
      <img class="left" src="../../assets/images/fkjz/替换内容1.png" alt="">
    </div>
    <div class="zd">
      <div class="hx"></div>
      <p>{{ data.xx.qy.desc }}</p>
      <p>{{ data.xx.qy.desc2 }}</p>
    </div>
    <div class="ewm">
      <div class="img">
        <img :src="data.xx.qrcode">
      </div>
      <h5>
        长按识别图中二维码<span>更有趣!</span>
      </h5>
      <p>让你的家变美，就是这么简单</p>
    </div>
    <div class="st">
      <img class="top" src="../../assets/images/fkjz/晒图1.png" alt="">
      <div class="nr">
        <div class="yq"></div>
        <div class="yq"></div>
        <div class="wa">
          <div class="left">
          <img src="../../assets/images/fkjz/1 拷贝.png" alt="">
          </div>
          <div class="right">
            <p>{{ data.xx.qy.qydesc }}</p>
            <div class="img">
              <img src="../../assets/images/fkjz/图层 2.png" alt="">
            </div>
          </div>
        </div>
        <div class="wa" v-for="(item,index) in data.xx.content" :key="index">
          <div class="left">
          <img src="../../assets/images/fkjz/1 拷贝.png" alt="">
          </div>
          <div class="right">
            <p>{{ item.desc }}</p>
            <div class="img">
              <img :src="item.image" alt="">
            </div>
          </div>
        </div>
        <!-- <div class="wa">
          <div class="left">
          <img src="../../assets/images/fkjz/1 拷贝.png" alt="">
          </div>
          <div class="right">
            <p>#逛了一天，梵客家装还是其他家？强大的朋友圈好友，我该选哪家？#</p>
            <div class="img">
              <img src="../../assets/images/fkjz/图层 2.png" alt="">
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="bm">
      <img class="top" src="../../assets/images/fkjz/咨询.png" alt="">
      <div class="xq">
        <span>您的姓名:*</span>
        <input type="text" placeholder="请输入姓名" v-model="data.user">
      </div>
      <div class="user">
        <span>您的电话:*</span>
        <input type="text" placeholder="请输入您的电话" v-model="data.tel">
      </div>
      <button @click="submit()">
        马上报名
      </button>
      <a class="tel" href="tel:13466669872">
        <img src="../../assets/images/fkjz/电话.png" alt="">
      </a>
      <img class="bottom" src="../../assets/images/fkjz/组 4.png" alt="">
    </div>
    <div class="tk" v-if="data.tk">
      <p>报名成功</p>
      <img src="../../assets/images/fkjz/装小白.jpg" alt="">
      <p>长按二维码可获取更多信息</p>
      <button @click="gbtk()">
        确定
      </button>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { isWeixin } from "@utils/index";
  import { getUserInfo } from "@api/user";
  import { wechatEvevt } from "@libs/wechat";
  export default {
    name: 'FkjzYqy',
    tx: '../../assets/images/fkjz/图层 10.png',
    data () {
      return {
        data: {
          user: '',
          tel: '',
          xx: '',
          tk: false,
          uid: ''
        },
      }
    },

    mounted() {
      var url = window.location.href ;             //获取当前url
      var dz_url = url.split('#')[0];                //获取#/之前的字符串
      var cs = dz_url.split('?')[1];                //获取?之后的参数字符串
      var shortName = cs.substring(0,10);
      var num= shortName.replace(/[^0-9]/ig,"");
      this.data.uid = num
      this.setOpenShare()
    },

    created() {
      // console.log(this.$route.query.id)
      // console.log(this.$route.query.xx.data)
      // this.data.xx = this.$route.query.xx.data
      this.getUserid()
    },

    methods: {
      setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              // desc: data.store_info,
              // title: '梵客家装狂欢惠',
              // link: href,
              // imgUrl: data.image,
              title: '梵客家装狂欢惠',
              link: window.location.href,
              desc: '#逛了一星期的家装公司，终于定下来了，价格惠民的梵客家装，期待帮我的家焕然一新#',
              imgUrl: 'http://yp.fkjz.cn/uploads/wechat/logo.jpg',
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              console.log(res);
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
          });
        } else {
          var configAppMessage = {
            // desc: data.store_info,
            // title: '梵客家装狂欢惠',
            // link: href,
            // imgUrl: data.image,
            title: '梵客家装狂欢惠',
            link: window.location.href,
            desc: '#逛了一星期的家装公司，终于定下来了，价格惠民的梵客家装，期待帮我的家焕然一新#',
            imgUrl: 'http://yp.fkjz.cn/uploads/wechat/logo.jpg',
          };

          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            console.log(res);
            if (res.is_ready) {
              res.wx.updateAppMessageShareData(configAppMessage);
              res.wx.updateTimelineShareData(configAppMessage);
            }
          });
        }
        }
      },

      submit() {
        if (this.data.tel.length !== 11) {
          alert('清输入正确的手机号')
        } else {
          axios({
            // headers: {'deviceCode': 'A95ZEF1-47B5-AC90BF3'},
            method: 'post',
            url: 'https://yp.fkjz.cn/api/wechat/getuser',
            data: {
              phone: this.data.tel,
              name: this.data.user
            },
            dataType: "json"
          })
          .then(res => {
            console.log(res)
            // this.$dialog.error(err.msg || "报名成功");
            // alert(res.data.msg)
            this.data.tk = true
          })
          .catch(err => {
            this.$dialog.error(err.msg || "报名失败");
          });
        }
      },

      getUserid () {
        var url = window.location.href ;             //获取当前url
        var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var cs = dz_url.split('?')[1];                //获取?之后的参数字符串
        var shortName = cs.substring(0,10);
        var num= shortName.replace(/[^0-9]/ig,"");
        this.data.uid = num
        axios({
          method: 'post',
          url: 'https://yp.fkjz.cn/api/wechat/getuserid',
          data: {
            id: num
          }
        })
        .then(res => {
          console.log(res.data)
          this.data.xx = res.data.data
        })
        .catch(err => {
          this.$dialog.error(err.msg || "提交失败");
        });
      },

      gbtk () {
        this.data.tk = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tk {
    position: fixed;
    left: 15%;
    top: 20%;
    width: 70%;
    background: #fff;
    padding: 1%;
    text-align: center;
    p {
      padding: 0.2rem 0;
    }
    img {
      width: 80%;
    }
    button {
      // padding: 0.1rem 0.3rem;
      width: 1.6rem;
      border-radius: 5px;
      height: 0.6rem;;
      background: -moz-linear-gradient(top, #fe00d3 0%, #9900eb 100%);
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#fe00d3), color-stop(100%,#9900eb));
      background: -webkit-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
      background: -o-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
      background: -ms-linear-gradient(top, #fe00d3 0%,#9900eb 100%);
      background: linear-gradient(to bottom, #fe00d3 0%,#9900eb 100%);
    }
  }

  .box {
    padding: 8% 7.5% 0 7.5%;
    width: 100%;
    // height: 100%;
    background: url("../../assets/images/fkjz/背景1.png") no-repeat;
    background-size: 100%;
  }

  .box .top .left {
    display: inline-block;
    width: 30%;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    line-height: 1rem;
    font-weight: 700;
    vertical-align: top;
  }

  .box .top .center {
    display: inline-block;
    width: 30%;
    height: 2rem;
    border-radius: 50px;
    overflow: hidden;
    background: #000;
    // margin: 0 0.2rem;
    margin: 0 2%;
    vertical-align: top;
  }

  .box .top .center img {
    width: 100%;
    height: 100%;
  }

  .box .top .right {
    display: inline-block;
    width: 35%;
    height: 2rem;
    // overflow: hidden;
    // background: #000;
    vertical-align: top;
  }

  .box .top .right .xx {
    margin-top: 0.55rem;
    width: 100%;
    height: 0.9rem;
  }

  .box .top .right p {
    display: inline-block;
    color: #fff;
    font-size: 0.3rem;
    width: 100%;
    vertical-align: top;
  }

  .box .top .right p span {
    display: inline-block;
    width: 62%;
    height: 0.4rem;
    line-height: 0.4rem;
    color: #fff;
    font-size: 0.28rem;
    vertical-align: top;
    overflow: hidden;
  }

  .wyqy {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .wyqy .left {
    width: 45%;
  }

  .zd .hx {
    width: 0.5rem;
    height: 3px;
    border-radius: 50px;
    margin-bottom: 0.2rem;
    background-color: #ffcd67;
  }

  .zd p {
    color: #fff;
    font-size: 0.35rem;
    line-height: 0.5rem;
  }

  .ewm {
    width: 100%;
    text-align: center;
    margin-top: 1rem;
  }

  .ewm .img {
    margin: 0 auto;
    width: 2.5rem;
    height: 2.5rem;
    padding: 0.1rem;
    background-color: #fff;
    border-radius: 10px;
  }

  .ewm .img img {
    width: 100%;
    height: 100%;
  }

  .ewm h5 {
    margin-top: 0.2rem;
    color: #fff;
    font-size: 0.35rem;
    line-height: 0.35rem;
    span {
      color: #f9c25d;
    }
  }

  .ewm p {
    display: inline-block;
    margin-top: 0.1rem;
    color: #fff;
    font-size: 0.25rem;
    border: #fff 1px solid;
    padding: 0 0.1rem;
    border-radius: 50px;
  }

  .st {
    width: 100%;
    .top {
      margin-top: 1rem;
      margin-bottom: 0.2rem;
      width: 60%;
      margin-left: 20%;
    }
    .nr {
      position: relative;
      border-left: 1px #999 solid;
      margin-top: 0.5rem;
      .yq {
        position: absolute;
        width: 0.2rem;
        height: 0.2rem;
        border: #fff 1.5px solid;
        border-radius: 50px;
        top: -0.2rem;
        left: -0.1rem;
      };
      .yq:nth-child(2) {
        left: -0.1rem;
        top: 100%
      }
      .wa {
        padding-top: 0.5rem;
        padding-bottom: 0.3rem;
        position: relative;
        left: -0.1rem;
        .left {
          width: 10%;
          display: inline-block;
          vertical-align: top;
          img {
            width: 0.2rem;
            height: 0.2rem;
            border-radius: 50px;
          }
        }
        .right {
          width: 90%;
          display: inline-block;
          vertical-align: top;
          p {
            color: #fff;
            font-size: 0.3rem;
            line-height: 0.45rem;
          }
          .img {
            width: 100%;
            height: 3.5rem;
            overflow: hidden;
            padding: 0.015rem;
            border-radius: 5px;
            background: -moz-linear-gradient(top, #99ddea 0%, #8e5ddc 100%);
            background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#99ddea), color-stop(100%,#8e5ddc));
            background: -webkit-linear-gradient(top, #99ddea 0%,#8e5ddc 100%);
            background: -o-linear-gradient(top, #99ddea 0%,#8e5ddc 100%);
            background: -ms-linear-gradient(top, #99ddea 0%,#8e5ddc 100%);
            background: linear-gradient(to bottom, #99ddea 0%,#8e5ddc 100%);
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .bm {
    margin-top: 0.5rem;
    width: 100%;
    padding-bottom: 0.3rem;
    .top {
      width: 60%;
      margin-left: 20%;
    }
    .user, .xq {
      width: 100%;
      margin-top: 0.3rem;
      height: 0.8rem;
      line-height: 0.8rem;
      background-color: #FFF;
      border-radius: 5px;
      padding: 0rem 0.5rem;
      span {
        color: #a0a0a0;
      }
      input {
        margin-left: 0.3rem;
      }
      input::-moz-placeholde {
        color: #c6c6c6
      }
      input::-ms-input-placeholder {
        color: #c6c6c6
      }
      input::-webkit-input-placeholder {
        color: #c6c6c6
      }
    }
    button {
      display: inline-block;
      margin-top: 0.3rem;
      border-radius: 5px;
      height: 0.8rem;
      width: 100%;
      color: #fbfbfb;
      font-size: 0.4rem;
      font-weight: 700;
      background: -moz-linear-gradient(top, #fe00d2 0%, #9700ec 100%);
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#fe00d2), color-stop(100%,#9700ec));
      background: -webkit-linear-gradient(top, #fe00d2 0%,#9700ec 100%);
      background: -o-linear-gradient(top, #fe00d2 0%,#9700ec 100%);
      background: -ms-linear-gradient(top, #fe00d2 0%,#9700ec 100%);
      background: linear-gradient(to bottom, #fe00d2 0#9700ec 100%);
    }
    .tel {
      display: inline-block;
      margin-left: 20%;
      margin-top: 0.3rem;
      img {
        width: 60%;
      }
    }

    .bottom {
      display: inline-block;
      margin-left: 25%;
      width: 50%;
    }
  }
</style>